@import 'styles/mixins';
@import 'styles/variables';

.datePickerField {
  color: $gray-40;
}

.errorMessage {
  @include ui-sm-text;
  color: $red-40;
  margin-bottom: 8px;
}

.label {
  @include ui-sm-text;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
}
